/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable @typescript-eslint/no-explicit-any */
import cn from 'classnames';

import { ExclamationIcon } from 'common/icons/ExclamationIcon';
import SupportTicketLink from 'common/components/SupportTicketLink';

import styles from './styles.module.scss';

const defaults = {
  contentMain: {
    unableToLoadPreviousVersion: () => (
      <div className={styles.contentMain}>
        Sorry we can&apos;t load this version at the moment. Try refreshing the
        browser or&nbsp;
        <SupportTicketLink>create a support ticket</SupportTicketLink>&nbsp;for
        more help.
      </div>
    ),
  },
};

export const LoadingError: React.FunctionComponent<{
  readonly contentMainType?: keyof (typeof defaults)['contentMain'];
  readonly iconHeight?: number;
  readonly iconWidth?: number;
  readonly propsActionButton?: React.HTMLProps<HTMLHeadingElement>;
  readonly propsTitle1: React.HTMLProps<HTMLButtonElement>;
  readonly textTitle: string;
}> = ({
  contentMainType = 'unableToLoadPreviousVersion',
  propsActionButton = {
    children: 'Retry',
  },
  propsTitle1,
}) => (
  <section className={styles.root}>
    <ExclamationIcon className={styles.iconTop} />

    <div
      {...(propsTitle1 as any)}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment
      className={cn(styles.title, propsTitle1?.className)}
    />

    {defaults.contentMain[contentMainType]()}

    <button
      onClick={() => window.location.reload()}
      type="button"
      {...(propsActionButton as any)}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
      className={cn(styles.buttonAction, propsActionButton?.className)}
    />
  </section>
);
